<template>
    <main class="school-mgn-list" style="background: #f5f5fb;">
        <div class="mainList">
            <el-form @submit.native.prevent :inline="true" label-width="80px" style="margin-left: 13px;padding: 5px 0">
                <el-form-item>
                    <InputTopTip v-model="selectedOptions" :placeholder="'省 / 市 / 区'">
                        <el-cascader :key="refreshItem" ref="cascaderArr" placeholder="" v-model="selectedOptions"
                            size="small" :options="options" :props="{
                                value: 'id',
                                label: 'name',
                                children: 'child',
                                expandTrigger: 'click',
                                emitPath: false,
                                checkStrictly: true
                            }" @change="handleChange($event, '省市区')">
                        </el-cascader>
                    </InputTopTip>
                </el-form-item>
                <el-form-item>
                    <InputTopTip v-model="filter_form.name" :placeholder="'学校名字'">
                        <el-input placeholder="" @keyup.native.enter="; (currentPage = 1), refreshDataList()"
                            v-model="filter_form.name" size="small">
                            <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
                        </el-input>
                    </InputTopTip>
                </el-form-item>
                <el-form-item>
                    <InputTopTip v-model="filter_form.fb_school_type" :placeholder="'学校类型'">
                        <el-select @change="handleChange($event, '学校类型')" v-model="filter_form.fb_school_type"
                            size="small" placeholder="">
                            <el-option v-for="item in schoolType" :key="item.val" :label="item.name"
                                :value="item.val"></el-option>
                        </el-select>
                    </InputTopTip>
                </el-form-item>
                <el-form-item>
                    <InputTopTip v-model="filter_form.fb_admin_level" :placeholder="'学校层级'">
                        <el-select @change="handleChange($event, '学校层级')" v-model="filter_form.fb_admin_level"
                            size="small" placeholder="">
                            <el-option v-for="item in schoolLevel.slice(1)" :key="item.val" :label="item.name"
                                :value="item.val"></el-option>
                        </el-select>
                    </InputTopTip>
                </el-form-item>


                <el-form-item>
                    <InputTopTip v-model="filter_form.fb_school_stage" :placeholder="'学校学段'">
                        <el-select multiple @change="handleChange($event, '学校学段')" v-model="filter_form.fb_school_stage"
                            size="small" placeholder="">
                            <el-option v-for="item in schoolStage.slice(0)" :key="item.val" :label="item.name"
                                :value="item.val"></el-option>
                        </el-select>
                    </InputTopTip>
                </el-form-item>

                <el-form-item prop="created_at">
                    <el-date-picker v-model="filter_form.created_at" type="daterange" size="small" range-separator="——"
                        start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd HH:mm:ss" @change="; (currentPage = 1), refreshDataList()"
                        :default-time="['00:00:00', '23:59:59']"></el-date-picker>
                </el-form-item>
                <!-- fb_admin_level -->
            </el-form>
            <div style="display: flex; margin-left: auto;">
                <template v-if="
                    $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
                    $store.state.user.userInfo.type === $api.account.types.OTHER.value
                ">
                    <el-button type="primary" class="action-btn" size="small" style="margin-right: 15px; width: 70px;"
                        @click="; (currentPage = 1), refreshDataList()">搜索</el-button>
                    <el-button type="primary" class="action-btn" size="small" style="
							background: #f7f8fa;
							border: 1px solid #dcdcdc;
							color: #4b4b4b !important;
							margin-right: 12px;
							width: 70px;
						" @click="clearList">重置</el-button>
                </template>
            </div>
        </div>
        <div>
            <section class="list-area">
                <div class="list-area-otis" v-if="
                    $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
                    $permissions([SP21001, SP21002, SP21005])
                ">
                    <template>
                        <div style="display: flex; padding-left: 18px;">
                            <el-button type="primary" size="small" icon="el-icon-plus" style="margin-right: 15px;"
                                @click="Newbuttont" v-permission="SP21001">新建</el-button>
                            <el-button size="small" icon="el-icon-download"
                                style="background: #f7f8fa; border: 2px solid #f7f8fa; color: #4b4b4b !important;"
                                @click="$refs.importDialog.dialogVisible = true" v-permission="SP21002">批量创建</el-button>
                        </div>
                        <div>
                            <el-button type="primary" size="small" icon="el-icon-delete"
                                :class="multipleSelection.length === 0 ? 'box' : 'box2'"
                                :disabled="multipleSelection.length === 0" @click="batchDelete()"
                                v-if="multipleSelection.length > 0" v-permission="SP21005">批量删除</el-button>
                        </div>
                    </template>
                </div>
                <el-table :data="dataList" row-class-name="row" tooltip-effect="dark"
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
                    wdith="100%">
                    <el-table-column type="selection" width="60" align="center"
                        v-if="$permissions([SP21005])"></el-table-column>
                    <el-table-column align="left" label="ID" prop="school_code" />
                    <el-table-column align="left" label="学校名称" prop="name" />
                    <el-table-column align="left" label="辖区" prop="district_division">
                        <template slot-scope="scope">
                            {{ scope.row.district_division.l1_name }}/{{ scope.row.district_division.l2_name }}{{
                                scope.row?.district_division?.l3_name ? '/' + scope.row?.district_division?.l3_name : ''
                            }}</template>
                    </el-table-column>
                    <el-table-column align="left" label="学段" prop="high_school,middle_school,primary_school">
                        <template slot-scope="scope">
                            {{ scope.row.primary_school === 1 ? '小学' : '' }} {{ scope.row.middle_school === 1 ? '初中' :
                            '' }}
                            {{ scope.row.high_school === 1 ? '高中' : '' }}</template>
                    </el-table-column>
                    <el-table-column align="left" label="校管" width="80">
                        <template v-slot:default="slot">
                            <router-link :to="{
                                name: 'schoolAdminManagement',
                                query: { school_id: slot.row.id, schoolAdminlist: slot.row }
                            }">
                                <el-link type="success">{{ slot.row.school_admins_count }}</el-link>
                            </router-link>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" label="教师" width="80">
                        <template v-slot:default="slot">
                            <router-link :to="{
                                name: 'teacherManagement',
                                query: { school_id: slot.row.id, teachlist: slot.row }
                            }">
                                <el-link type="success">{{ slot.row.teachers_count }}</el-link>
                            </router-link>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" label="班级" width="80">
                        <template v-slot:default="slot">
                            <router-link :to="{
                                name: 'classgradeManagement',
                                query: { school_id: slot.row.id, classlist: slot.row }
                            }">
                                <el-link type="success">{{ slot.row.class_grades_count }}</el-link>
                            </router-link>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" label="学生" prop="" width="80">
                        <template v-slot:default="slot">
                            <router-link :to="{
                                name: 'studentManagement',
                                query: { school_id: slot.row.id, studentlist: slot.row }
                            }">
                                <el-link type="success">{{ slot.row.students_count }}</el-link>
                            </router-link>
                        </template>
                    </el-table-column>
                    <!-- 1.1.1需求， 表格8要求暂时隐藏-->
                    <el-table-column align="left" label="学校层级" prop="admin_level">
                        <template v-slot:default="{ row }">
                            <div>{{schoolLevel.find(item => item.val == row.admin_level)?.name}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" label="学校类型" prop="school_type">
                        <template v-slot:default="{ row }">
                            <div>{{schoolType.find(item => item.val == row.school_type)?.name}}</div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column align="left" label="指标分值显示方式" prop="show_type" width="140">
						<template v-slot:default="{ row }">
							<div>{{ scores.find(item => item.val == row.show_type)?.name }}</div>
						</template>
					</el-table-column> -->
                    <el-table-column align="left" label="创建时间" prop="created_at" width="180">
                        <template v-slot:default="{ row }">{{ row?.created_at?.replace(/-/g, '/') }}</template>
                    </el-table-column>
                    <template v-if="
                        $store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
                        $permissions([SP21003, SP21004])
                    ">
                        <el-table-column align="center" label="操作" class-name="opscol">
                            <template v-slot:default="slot">
                                <div class="table-mgn" _flex="!~ justify-center" style="width: 100%;">
                                    <div style="color: #3f6af7;" @click="Editbutton(slot.row.id)"
                                        v-permission="SP21003">
                                        <el-tooltip content="编辑" placement="bottom" effect="light">
                                            <svg class="icon" aria-hidden="true">
                                                <use xlink:href="#icon-iconoutlinesetting"></use>
                                            </svg>
                                        </el-tooltip>
                                    </div>

                                    <div class="icon delete" style="color: #f13048;" @click="promptRemove(slot.row.id)"
                                        v-permission="SP21004">
                                        <el-tooltip content="删除" placement="bottom" effect="light">
                                            <svg class="icon" aria-hidden="true"
                                                style="width: 100%; height: 100%; outline: none; box-shadow: none;">
                                                <use xlink:href="#icon-deltred"></use>
                                            </svg>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
                <div class="pagination-page">
                    <span class="pagetotal">总计：{{ totalItems }}条/{{ Math.ceil(totalItems / pageSize) }}页</span>
                    <el-pagination class="pagination" background @size-change="handleSizeChange"
                        @current-change="handleCurrentChange" :page-size="pageSize" :total="totalItems"
                        :current-page.sync="currentPage" :page-sizes="[10, 20, 50, 100]"
                        layout="prev,pager,next,jumper,sizes" style="margin-top: 21px; margin-left: 10px;">
                    </el-pagination>
                </div>
            </section>
        </div>
        <el-dialog class="practice-sheet-new-edit-dialog" width="540px" :close-on-click-modal="false"
            :destroy-on-close="true" :visible="practiceSheetNewEditDialog" @close="practiceSheetNewEditDialogClose">
            <div class="dialog-title2" slot="title">
                <span>{{ dialogTitleType }}学校</span>
                <el-divider></el-divider>
            </div>
            <template>
                <el-form :model="model" ref="newForm" :rules="vaRules" @submit.native.prevent="confirm">
                    <el-form-item v-if="dialogTitleType === '编辑'">
                        <div :class="arereid === 2 ? 'arere' : ''">
                            <InputTopTip v-model="newselectedOptions" :placeholder="'辖区'" :marginTop="14">
                                <el-cascader ref="areaRef" v-model="newselectedOptions" style="width: 100%;"
                                    size="medium" placeholder="" :options="options2" :props="{
                                        value: 'id',
                                        label: 'name',
                                        children: 'child',
                                        emitPath: false
                                    }" @expand-change="expandleChange(options2)" @change="handleChange2($event)" />
                            </InputTopTip>
                        </div>
                    </el-form-item>
                    <el-form-item prop="newselectedOptions" v-else>
                        <div :class="arereid === 2 ? 'arere' : ''">
                            <InputTopTip v-model="newselectedOptions" :placeholder="'辖区'" :marginTop="14">
                                <el-cascader ref="areaRef" v-model="newselectedOptions" style="width: 100%;"
                                    size="medium" placeholder="" :options="options2" :props="{
                                        value: 'id',
                                        label: 'name',
                                        children: 'child',
                                        emitPath: false
                                    }" @expand-change="expandleChange(options2)" @change="handleChange2($event)" />
                            </InputTopTip>
                        </div>
                    </el-form-item>
                    <el-form-item prop="name" style="margin-top: 25px;">
                        <InputTopTip v-model="model.name" :placeholder="'学校名称'" :marginTop="14">
                            <el-input placeholder="" v-model="model.name" @input="e => (model.name = validForbid(e))"
                                style="width: 100%;" size="medium" />
                        </InputTopTip>
                    </el-form-item>

                    <el-form-item prop="checkList" style="margin-top: 23px;">
                        <span _text="16px [#323232]" _p="b-1px" _m="t-3px"
                            style="font-family: PingFang SC-Medium, PingFang SC; font-weight: 500; -webkit-background-clip: text;">学段</span>
                        <el-checkbox-group v-model="checkList">
                            <el-checkbox label="primary_school">小学</el-checkbox>
                            <el-checkbox label="middle_school">初中</el-checkbox>
                            <el-checkbox label="high_school">高中</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <!-- 1.1.1需求， 表格8要求暂时隐藏-->
                    <!-- <el-form-item style="margin-top: 10px;">
						<span
							_text="16px [#323232]"
							_p="b-1px"
							_m="t-3px"
							style="font-family: PingFang SC-Medium, PingFang SC; font-weight: 500; -webkit-background-clip: text;"
							>指标分值显示方式</span
						>
						<div>
							<el-radio
								v-model="newParams.show_type"
								:key="item.val"
								:label="item.val"
								v-for="item in scores.slice(1)"
								>{{ item.name }}</el-radio
							>
						</div>
					</el-form-item> -->
                    <el-form-item style="margin-top: 10px;">
                        <span _text="16px [#323232]" _p="b-1px" _m="t-3px"
                            style="font-family: PingFang SC-Medium, PingFang SC; font-weight: 500; -webkit-background-clip: text;">学校类型</span>
                        <div>
                            <el-radio v-model="newParams.school_type" :key="item.val" :label="item.val"
                                v-for="item in schoolType">{{
                                item.name
                                }}</el-radio>
                        </div>
                    </el-form-item>
                    <el-form-item style="margin-top: 10px;">
                        <span _text="16px [#323232]" _p="b-1px" _m="t-3px"
                            style="font-family: PingFang SC-Medium, PingFang SC; font-weight: 500; -webkit-background-clip: text;">学校层级</span>
                        <div>
                            <el-radio v-model="newParams.admin_level" :key="item.val" :label="item.val"
                                v-for="item in schoolLevel.slice(1)">{{ item.name }}</el-radio>
                        </div>
                    </el-form-item>

                    <div style="margin-top: 25px;">
                        <el-divider></el-divider>
                    </div>
                    <el-form-item
                        style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;">
                        <el-button class="btn-close" @click="practiceSheetNewEditDialogClose"
                            style="width: 80px; height: 32px; line-height: 1px;">取 消</el-button>
                        <el-button class="btn-prim" type="primary" native-type="submit"
                            style="width: 80px; height: 32px; line-height: 1px;">{{ onTitleType }}</el-button>
                    </el-form-item>
                </el-form>
            </template>
        </el-dialog>
        <!-- 批量导入 -->
        <batch-import-account ref="importDialog" :target="'school'" />
    </main>
</template>
<script>
import { schoolType, scores, schoolLevel, schoolStage } from './const.js'
import { SP21001, SP21002, SP21003, SP21004, SP21005 } from '@/utils/permissionMap.js'
import BatchImportAccount from '@/components/BatchImportAccount'
import { throttle } from 'lodash'
export default {
    props: [],
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            SP21001,
            SP21002,
            SP21003,
            SP21004,
            SP21005,
            areaOptions: {},
            options: [],
            options2: [],
            options3: [],
            selectedOptions: [], //列表省市区
            listId: null,
            refreshItem: 0,
            arereid: 1, //编辑辖区颜色id
            //新建省市区
            newareaOptions: {},
            newselectedOptions: [],
            checkList: [],
            newlistId: null,
            model: {
                name: '',
                Perfect: '省 / 市 / 区' //回显省市区
            },
            newParams: { show_type: '', school_type: '', admin_level: '' },
            EditId: null,
            schoolType,
            schoolLevel,
            schoolStage,
            scores,
            vaRules: {
                name: [
                    {
                        required: true,
                        message: '请输入学校名称',
                        trigger: 'change'
                    }
                ],
                newselectedOptions: [
                    {
                        type: 'array',
                        validator: (rule, value, callback) => {
                            if (this.newselectedOptions.length === 0) {
                                callback(new Error('请选择省/市/区'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'change'
                    }
                ],
                checkList: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.checkList.length === 0) {
                                callback(new Error('学段至少勾选一个'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'change'
                    }
                ]
            },
            dialogTitleType: '', //新建||编辑
            onTitleType: '', //确定||更新
            activeTab: 'personal',
            filter_form: {
                bureauFilter: null,
                name: '',
                fb_school_type: '',
                fb_admin_level: '',
                created_at: [],
                fb_school_stage:[],
            },
            bureauList: [],
            dataList: [],
            pageSize: 10,
            totalItems: 0,
            currentPage: 1, // 第几页
            multipleSelection: [], // 批量删除
            currentPracticeSheetObj: null,
            dialogVisible: false,
            practiceSheetNewEditDialog: false //设置新建班级弹窗
        }
    },
    components: {
        BatchImportAccount
    },
    async created() {
        /* this.getNewAreaOptions()
        this.getAreaOptions() */
        this.RegionalLevel()
        try {
            const { page, page_size, fb_school_type, region_code, fu_name, fb_admin_level, fb_school_stage, start, end } = this.$store.state.searchParams[this.$route.name]
            this.currentPage = page
            this.pageSize = page_size
            this.filter_form.fb_school_type = fb_school_type
            this.listId = region_code
            this.selectedOptions = Number(this.listId) ? Number(this.listId) : []
            this.filter_form.name = fu_name
            this.filter_form.fb_admin_level = fb_admin_level
            this.filter_form.fb_school_stage = fb_school_stage
            this.filter_form.created_at = [start, end]
            this.refreshDataList()
        } catch (err) {
            console.log('正常~')
            this.refreshDataList()
        }
    },
    methods: {
        input(ev) {
            console.log(ev, '=')
        },
        async RegionalLevel() {
            this.$api.school
                .ssxlist(0)
                .then(res => {
                    this.options = this.removeEmptyItems(res)
                    this.options3 = res
                })
                .catch(err => {
                    console.log('获取列表报错')
                })
        },
        getAreaData(data = { deep: 0, value: 0, code: null }) {
            return new Promise(resolve => {
                this.$api.school.ssxlist(data.value).then(res => {
                    resolve(res && res && res) // 将获取到的数据传出
                })
            })
        },
        getAreaOptions() {
            let _this = this
            this.areaOptions = {
                lazy: true,
                lazyLoad(node, resolve) {
                    const { level } = node
                    // 调用后端接口获取数据
                    _this.getAreaData(node.data).then(data => {
                        const nodes = data.map(item => ({
                            leaf: level >= 2,
                            label: item.name,
                            value: item.id,
                            code: item.code,
                            level
                        }))
                        resolve(nodes)
                    })
                }
            }
        },
        getnewAreaData(data = { deep: 0, value: 0 }) {
            return new Promise(resolve => {
                this.$api.school.ssxlist(data.value).then(res => {
                    resolve(res && res && res) // 将获取到的数据传出
                })
            })
        },
        getNewAreaOptions() {
            let _this = this
            this.newareaOptions = {
                lazy: true,
                lazyLoad(node, resolve) {
                    const { level } = node
                    // 调用后端接口获取数据
                    _this.getnewAreaData(node.data).then(data => {
                        const nodes = data.map(item => ({
                            leaf: level >= 2,
                            label: item.name,
                            value: item.id,
                            code: item.code,
                            level
                        }))
                        resolve(nodes)
                    })
                }
            }
        },
        Newbuttont() {
            this.arereid = 1
            this.newParams.show_type = this.scores.slice(1)[0].val
            // 产品需求用的 ~ 书荣
            // this.newParams.school_type = this.schoolType[0].val
            this.newParams.school_type = this.schoolType[2].val
            this.newParams.admin_level = this.schoolLevel.slice(1)[0].val
            this.dialogTitleType = '新建'
            this.onTitleType = '确定'
            this.options2 = this.options3
            this.practiceSheetNewEditDialog = true
        },
        async Editbutton(id) {
            this.arereid = 2
            this.dialogTitleType = '编辑'
            this.onTitleType = '更新'
            this.options2 = this.options3
            this.EditId = id
            let res = null
            res = await this.$api.school.editlist(id)
            if (this.dialogTitleType === '编辑') {
                this.newlistId = res.district_division.id
                if (res.primary_school) {
                    this.checkList.push('primary_school')
                }
                if (res.middle_school) {
                    this.checkList.push('middle_school')
                }
                if (res.high_school) {
                    this.checkList.push('high_school')
                }
                this.model.name = res.name
                this.newParams.admin_level = res.admin_level
                this.newParams.show_type = res.show_type
                this.newParams.school_type = res.school_type
                // eslint-disable-next-line no-unused-vars
                for (let i in res.district_division) {
                    var arr = [] //声明一个新的数组
                    arr.push({
                        province: res.district_division.l1_name, //把省份保存到新的数组里
                        city: res.district_division.l2_name, //把市保存到新的数组里
                        county: res.district_division.l3_name //把区保存到新的数组里
                    })
                }
                //进一步处理成可以回显的数据
                arr.map(item => {
                    this.model.Perfect = item.province + '/' + item.city + '/' + item.county
                })
                this.practiceSheetNewEditDialog = true
                this.newselectedOptions = Number(res.district_division.code)

            }
        },
        removeEmptyItems(arr) {
            const newArr = []
            for (let i = 0; i < arr.length; i++) {
                const item = arr[i]
                if (item.child?.length >= 1) {
                    item.child = this.removeEmptyItems(item.child)
                } else {
                    item.child = undefined
                }
                newArr.push(item)
            }
            return newArr
        },
        expandleChange(list) {
            for (var i = 0; i < list?.length; i++) {
                if (list[i].child?.length < 1) {
                    list[i].child = undefined
                } else {
                    this.expandleChange(list[i]?.child)
                }
            }
            return list
        },
        handleVisibleChange(flag) {
            if (flag && this.$refs.cascaderArr.getCheckedNodes()[0] == null) {
                this.$refs.cascaderArr.$refs.panel.initStore()
            }
        },
        handleChange(row, type) {
            switch (type) {
                case '省市区': {
                    let checkedNode = this.$refs['cascaderArr'].getCheckedNodes()
                    this.listId = checkedNode[0].data.code
                    break
                }
                case '学校类型':
                    this.page = 1
                    break
                case '学校层级':
                    this.page = 1
                    break
            }
            this.refreshDataList()
        },
        handleChange2(row) {
            const checkedNode = this.$refs['areaRef'].getCheckedNodes()
            this.newlistId = checkedNode[0].data.code
        },
        async practiceSheetNewEditDialogClose() {
            this.currentPracticeSheetObj = null
            this.practiceSheetNewEditDialog = false
            this.EditId = null
            this.checkList = []
            this.newlistId = null
            this.$set(this.model, 'name', '')
            this.$set(this.model, 'Perfect', '省 / 市 / 区')
            this.newselectedOptions = []
            this.options2 = null
            this.dialogTitleType = ''
        },
        //
        confirm: throttle(function () {
            // async confirm() {
            this.$refs['newForm'].validate(async valid => {
                if (valid) {
                    this.model.primary_school = false
                    this.model.middle_school = false
                    this.model.high_school = false
                    for (var prop in this.checkList) {
                        this.model[this.checkList[prop]] = true
                    }
                    if (this.onTitleType == '确定') {
                        this.$api.school
                            .create({
                                name: this.model.name,
                                region_code: this.newlistId,
                                primary_school: this.model.primary_school,
                                middle_school: this.model.middle_school,
                                high_school: this.model.high_school,
                                ...this.newParams
                            })
                            .then(cRes => {
                                this.$message.success('新建成功')
                                this.practiceSheetNewEditDialogClose()
                                this.refreshDataList()
                                // this.refreshDataList1()
                            })
                    } else if (this.onTitleType == '更新') {
                        this.$api.school
                            .update(this.EditId, {
                                name: this.model.name,
                                region_code: this.newlistId,
                                primary_school: this.model.primary_school,
                                middle_school: this.model.middle_school,
                                high_school: this.model.high_school,
                                ...this.newParams
                            })
                            .then(cRes => {
                                this.$message.success('更新成功')
                                this.practiceSheetNewEditDialogClose()
                                // this.refreshDataList1()
                                this.refreshDataList()
                            })
                    }
                } else {
                    console.log('error')
                }
            })
        }, 3000),
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        //每页下拉只显示的数据
        handleSizeChange(val) {
            this.currentPage = 1
            this.pageSize = val
            this.refreshDataList()
        },
        //当前点击的是第几页
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage
            this.refreshDataList()
        },
        async refreshDataList() {
            let res = null
            const params = {
                page: this.currentPage,
                page_size: this.pageSize,
                fu_name: this.filter_form.name,
                fb_school_type: this.filter_form.fb_school_type,
                region_code: this.listId,
                fb_admin_level: this.filter_form.fb_admin_level,
                fb_school_stage: this.filter_form.fb_school_stage,
                start: this.filter_form.created_at ? this.filter_form.created_at[0] : '',
                end: this.filter_form.created_at ? this.filter_form.created_at[1] : '',
            }
            this.$store.commit('setSearchParams', { key: this.$route.name, params })
            res = await this.$api.school.list(params)
            this.totalItems = res.meta.total
            this.pageSize = parseInt(res.meta.per_page)
            this.dataList = res.data
        },
        async refreshDataList1() {
            let res = null
            res = await this.$api.school.list({
                page: this.currentPage,
                page_size: this.pageSize,
                fu_name: null,
                region_code: null
            })
            this.totalItems = res.meta.total
            this.pageSize = parseInt(res.meta.per_page)
            this.dataList = res.data
        },

        clearList() {
            this.filter_form.name = ''
            this.filter_form.fb_school_type = ''
            this.filter_form.fb_admin_level = ''
            this.filter_form.created_at = []
            this.filter_form.fb_school_stage = []
            this.listId = null
            this.selectedOptions = []
            this.refreshItem++
            this.refreshDataList()
        },
        //批量删除数据
        batchDelete() {
            this.$confirm('此操作将永久删除该学校以及附属数据, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(res => {
                    let idse = this.multipleSelection.map(item => item.id)
                    this.$api.school
                        .SchoolDeletes({
                            ids: idse
                        })
                        .then(cRes => {
                            if (cRes.success === true) {
                                this.$message.success('删除成功，请刷新数据')
                                this.refreshDataList()
                            }
                        })
                })
                .catch(() => { })
        },
        promptRemove(id) {
            this.$confirm('此操作将永久删除该学校以及附属数据, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await this.$api.school.delete(id)
                // 刷新
                this.$message.success('删除成功，请刷新数据')
                this.refreshDataList()
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.arere {
    /deep/ .el-cascader .el-input .el-input__inner::placeholder {
        color: #323232;
    }
}

.action-btn:focus {
    background-color: #ff5e2a;
    border-color: #ff5e2a;
    opacity: 1 !important;
}

.box {
    margin-right: 15px;
    background: #9f9f9f;
    border: 2px solid #f7f8fa;
    color: #4b4b4b !important;
}

.box:hover {
    margin-right: 15px;
    background: #9f9f9f;
    border: 2px solid #f7f8fa;
    color: #4b4b4b !important;
}

.box2 {
    margin-right: 15px;
    background: #f7f8fa;
    border: 2px solid #f7f8fa;
    color: #4b4b4b !important;
}

.pagetotal {
    width: 200px;
    margin-left: 20px;
    font-size: 14px;
    line-height: 70px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #010101;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.addr {
    font-size: 14px;
    color: #b4b4b4;
}

.schoolNianji {
    width: 32px;
    height: 28px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #323232;
    line-height: 28px;
    -webkit-background-clip: text;
}

.schollAxie {
    height: 35px;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    vertical-align: middle;
    -webkit-box-align: center;
    align-items: center;
}

.schollApex {
    width: 32px;
    height: 28px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #323232;
    line-height: 28px;
    -webkit-background-clip: text;
    display: flex;
}

.el-form-item {
    margin-bottom: 1px;
}

.pagination {
    width: 100%;
    margin-top: 20px;
    text-align: right;
}

.pagination .el-pagination__total {
    float: left;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #010101;
    -webkit-background-clip: text;
}

.pagination .el-pagination__jump {
    margin-left: 9px;
    font-weight: normal;
    color: #666666;
}

.ClassesRadio {
    margin-right: 32px;
    padding-bottom: 15px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #323232;
    -webkit-background-clip: text;
}

.ClassChekbox {
    margin-right: 8px;
    width: 90px;
    height: 32px;
    padding-bottom: 0px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #323232;
    -webkit-background-clip: text;
}
</style>
